module.exports = __webpack_public_path__ + "img/project-edu-04.0548c2b3.png";